import { useFormikContext } from 'formik';
import React from 'react';
import { InputLabel, Poppins, Spacer } from 'src/common';
import Input from 'src/components/form/Input';
import {
  BillingTypeSelect,
  BusinessTypeSelect,
  EnvironmentTypeSelect,
  OrganisationTypeSelect,
  PlanTypeSelect,
  ServiceModelSelect,
} from 'src/components/select';
import { SettingsOptions, UpsertOrganisationMutationVariables } from 'src/graphql/_generated';
import styled from 'styled-components';

const Div = styled.div`
  .workspace-create-question {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    &__option {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
`;

interface Step2Props {
  selectedSettingsOption?: SettingsOptions;
  createWorkspace: boolean;
  onCreateWorkspaceChange: (value: boolean) => void;
}

export const Step2: React.FC<Step2Props> = ({ selectedSettingsOption, createWorkspace, onCreateWorkspaceChange }) => {
  const { values, errors, touched, setFieldValue, setFieldTouched } =
    useFormikContext<UpsertOrganisationMutationVariables>();

  return (
    <Div>
      <InputLabel>ORGANISATION TYPE</InputLabel>
      <OrganisationTypeSelect
        onChange={(o) => {
          setFieldValue('organisationType', o.value);

          setFieldValue('businessType', null);
          setFieldValue('planType', null);
          setFieldValue('billingType', null);
          setFieldValue('serviceModel', null);
          setFieldValue('environmentType', null);
        }}
        onBlur={() => setFieldTouched('organisationType', true)}
        value={values.organisationType}
        css="width: 100%;"
        error={touched.organisationType && Boolean(errors.organisationType)}
      />
      <Spacer $px={20} />

      <InputLabel>SERVICE MODEL</InputLabel>
      <ServiceModelSelect
        filteredOptions={selectedSettingsOption?.serviceModel?.map((o) => o!)}
        onChange={(o) => setFieldValue('serviceModel', o.value)}
        onBlur={() => setFieldTouched('serviceModel', true)}
        value={values.serviceModel}
        css="width: 100%;"
        error={touched.serviceModel && Boolean(errors.serviceModel)}
      />
      <Spacer $px={20} />

      <InputLabel>BUSINESS TYPE</InputLabel>
      <BusinessTypeSelect
        filteredOptions={selectedSettingsOption?.businessType?.map((o) => o!)}
        onChange={(o) => setFieldValue('businessType', o.value)}
        onBlur={() => setFieldTouched('businessType', true)}
        value={values.businessType}
        css="width: 100%;"
        error={touched.businessType && Boolean(errors.businessType)}
      />
      <Spacer $px={20} />

      <InputLabel>BILLING TYPE</InputLabel>
      <BillingTypeSelect
        filteredOptions={selectedSettingsOption?.billingType?.map((o) => o!)}
        onChange={(o) => setFieldValue('billingType', o.value)}
        onBlur={() => setFieldTouched('billingType', true)}
        value={values.billingType}
        css="width: 100%;"
        error={touched.billingType && Boolean(errors.billingType)}
      />
      <Spacer $px={20} />

      <InputLabel>PRICING PLAN</InputLabel>
      <PlanTypeSelect
        filteredOptions={selectedSettingsOption?.planType?.map((o) => o!)}
        onChange={(o) => setFieldValue('planType', o.value)}
        onBlur={() => setFieldTouched('planType', true)}
        value={values.planType}
        css="width: 100%;"
        error={touched.planType && Boolean(errors.planType)}
      />
      <Spacer $px={20} />

      <InputLabel>ENVIRONMENT TYPE</InputLabel>
      <EnvironmentTypeSelect
        filteredOptions={selectedSettingsOption?.environmentType?.map((o) => o!)}
        onChange={(o) => setFieldValue('environmentType', o.value)}
        onBlur={() => setFieldTouched('environmentType', true)}
        value={values.environmentType}
        css="width: 100%;"
        error={touched.environmentType && Boolean(errors.environmentType)}
      />

      <Spacer $px={20} />
      <div className="workspace-create-question">
        <Poppins px={14} color="cflowerBlue">
          Would you like to create a workspace
          <br /> within this organisation?
        </Poppins>
        <div className="workspace-create-question__option">
          <Poppins px={14} weight={500} color="cflowerBlue">
            No
          </Poppins>
          <Input
            checked={createWorkspace}
            onChange={(e) => onCreateWorkspaceChange(e.target.checked)}
            className="switch"
            type="checkbox"
          />
          <Poppins px={14} weight={500} color="cflowerBlue">
            Yes
          </Poppins>
        </div>
      </div>
    </Div>
  );
};
